import { AutocompleteDefaultOption } from '@wppopen/components-library'
import {
  FormReducerSingleTextField,
  FormReducerListField,
  FormReducerSelectField,
  ErrorType,
} from 'reducers/FormReducer/utils'
import formReducer, {
  formHelperMethodFactory,
  emptySingleInputField,
  emptySelectField,
  emptyListField,
  errorAndWarningAttributes,
} from 'reducers/FormReducer/FormReducer'

export interface RegionFormReducerState {
  name: FormReducerSingleTextField
  locale: FormReducerSelectField
  flag: FormReducerSelectField
  retailers: {
    value: AutocompleteDefaultOption[]
    error?: ErrorType
    warning?: ErrorType
    type: 'autocomplete'
  }
  guidelines: FormReducerListField
}

export const emptyRegionFormReducerState: RegionFormReducerState = {
  name: { ...emptySingleInputField },
  locale: { ...emptySelectField },
  flag: { ...emptySelectField },
  retailers: { value: [], type: 'autocomplete', ...errorAndWarningAttributes },
  guidelines: { ...emptyListField },
}

export type UpdateInputField = keyof Pick<RegionFormReducerState, 'name'>
export type UpdateSelectField = keyof Pick<RegionFormReducerState, 'locale' | 'flag'>
export type UpdateAutoCompleteField = keyof Pick<RegionFormReducerState, 'retailers'>
export type SelectField = 'locale' | 'flag'
export type UpdateRegionListField = 'guidelines'

// Get helper methods from the factory
export const {
  updateSingleInput,
  addListItem,
  removeListItem,
  replaceListItem,
  handleError,
  updateSelect,
  setSelect,
  resetForm,
  updateAutoComplete,
} = formHelperMethodFactory<'RegionFormReducerState'>()

// Alias updateSingleInput as updateInput for backward compatibility
export const updateInput = updateSingleInput

// Transform API data to form state
export const transformRegionData = (regionData: any, configRetailers: any): RegionFormReducerState => {
  return {
    name: { ...emptySingleInputField, value: regionData.name },
    locale: { ...emptySelectField, value: regionData.locale },
    flag: { ...emptySelectField, value: regionData.flag },
    retailers: {
      value: regionData.retailers.map((retailerId: string) => {
        const retailer = configRetailers.find((r: any) => r._id === retailerId)
        return {
          id: retailerId,
          label: retailer?.name || 'Unknown Retailer',
        }
      }),
      type: 'autocomplete',
      ...errorAndWarningAttributes,
    },
    guidelines: {
      ...emptyListField,
      value: regionData.guidelines || [],
    },
  }
}

export default formReducer
